var GOOGLE_PLACES_API_KEY = 'AIzaSyAmR_sHqVLIL8Pf2vpbF6cA7Ufg8xPlVNc';

document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('form[action^="/contact"]');
  if (!form) return;

  var addressInput = form.querySelector('input[name="contact[Adresse]"]');
  if (!addressInput) return;

  var postalCodeInput = form.querySelector('input[name="contact[Code postal]"]');

  function getComponent(components, types, useShortName) {
    for (var t = 0; t < types.length; t++) {
      for (var i = 0; i < components.length; i++) {
        if (components[i].types.indexOf(types[t]) !== -1) {
          return useShortName ? components[i].short_name : components[i].long_name;
        }
      }
    }
    return null;
  }

  window.__nsdInitGooglePlaces = function () {
    if (!window.google || !window.google.maps || !window.google.maps.places) return;

    var autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ['address'],
      componentRestrictions: { country: 'ca' },
      fields: ['formatted_address', 'address_components']
    });

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      var components = place && place.address_components;
      if (!components) return;

      var streetNumber = getComponent(components, ['street_number']);
      var route = getComponent(components, ['route']);
      // Smaller/rural municipalities aren't always tagged "locality" —
      // fall through broader admin levels until one is found.
      var city = getComponent(components, ['locality', 'sublocality', 'administrative_area_level_3', 'administrative_area_level_2']);
      var province = getComponent(components, ['administrative_area_level_1'], true);
      var country = getComponent(components, ['country']);
      // Full postal code isn't always available — Google sometimes only has
      // FSA-level precision (the 3-character prefix, e.g. "G0R") for
      // addresses outside dense urban areas.
      var postalCode = getComponent(components, ['postal_code']) || getComponent(components, ['postal_code_prefix']);

      var street = [streetNumber, route].filter(Boolean).join(' ');
      var line = [street, city, province, country, postalCode].filter(Boolean).join(', ');

      // Note: deliberately not dispatching an "input" event here — Google's
      // Autocomplete widget listens for input events on this same field to
      // fetch/show suggestions, so firing one ourselves re-triggers it and
      // leaves the "Powered by Google" dropdown stuck open. Setting .value
      // directly is enough: the floating label and form submission both
      // read the live DOM value, no event needed.
      addressInput.value = line || place.formatted_address || '';

      if (postalCodeInput && postalCode) {
        postalCodeInput.value = postalCode;
        postalCodeInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  };

  var script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(GOOGLE_PLACES_API_KEY) + '&libraries=places&callback=__nsdInitGooglePlaces&loading=async';
  script.async = true;
  document.head.appendChild(script);
});
